export default "__VITE_PUBLIC_ASSET__a4891e24__"